interface ConstantProps {
  [key: string]: JSX.Element;
}

export const NATIONALITY_HISTORY: ConstantProps = {
  '2026.04.15': (
    <div className="terms-body">
      &apos;주식회사 오픈서베이&apos;는 이용자의 국적 정보를 다음과 같이 수집 및
      이용하고자 합니다.
      <p>- 수집 항목: 국적</p>
      <p>- 수집 목적: 국가별 맞춤 설문 발송</p>
      <p>
        - 보유 및 이용기간: 회원 탈퇴 시 또는 동의 철회 시까지 보유 (이용기간
        종료 시 지체 없이 파기)
      </p>
      <p>
        국적 정보는 개인의 특성을 나타내는 정보로서 보호가 필요하므로, 회사는
        이를 안전하게 관리하고 최소한으로 처리합니다.
      </p>
      <p className="second_level">
        ※ 귀하는 위 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며,
        동의를 거부하더라도 서비스 이용에는 제한이 없습니다. 다만, 국적별 맞춤
        설문 대상에서 제외될 수 있습니다.
      </p>
      <br />
    </div>
  ),
};
